import React, { Component } from "react";
import env from "react-dotenv";
import { connect } from "react-redux";
import { cekCookies } from "../../../actions";
import __ from "lodash";
import { Alert } from "react-bootstrap";
import LoaderModal from "../../../components/modal/LoaderModal";
import Navbar from "../../../components/dashboard/navbar/Navbar";
import Sidebar from "../../../components/dashboard/sidebar/Sidebar";
import { CONFIG } from "../../../config";
import accountManagement from "../../../apis/accountManagement";

import DropdownTahunAjaran from "../../../components/dashboard/content/masterDropDown/DropdownTahunAjaran";
import DropdownKelas from "../../../components/dashboard/content/masterDropDown/DropdownKelas";
import DropdownKelasParalel from "../../../components/dashboard/content/masterDropDown/DropdownKelasParalel";
import KelasSearch from "../../../entity/KelasSearch";
import KelasParalelSearch from "../../../entity/KelasParalelSearch";
import { Grid, TextField, Typography } from "@material-ui/core";

import ReqKuotaPemetaan from "../../../entity/ReqKuotaPemetaan";
import { Gap } from "../../../components/Global";
import ListSiswa from "./Component/ListSiswa";

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ta: [],
            kelas: [],
            jadwalCbt: [],
            KelasParalelSearch: [],
            listSiswa: [],
            kodeTahunAjaran: null,
            allInput: 0,
            reqKuotaPemetaan: ReqKuotaPemetaan,
            alert: {
                errorCode: null,
                errorMessage: null,
            },
            urlSiswaReportingSMK: env.REACT_APP_URL_SISWA_FE + "/pemetaan/reporting_smk.html?",
            urlSiswaReportKU: "/report_pemetaan_ku/",
            dataInputKuota: [],
        };
    }

    async componentDidMount() {
        this.setState({ isFetching: true });
        await this.props.cekCookies();
        if (!__.isEmpty(this.props.account)) {
            this.fetchTa();
            this.fetchKelas();
        }
        this.setState({ isFetching: false });

        if (this.props.location.pathname === "/report_pemetaan_input2") {
            this.setState({
                dataInputKuota: [
                    { label: "Kuota Pariwisata", id: "kuotaPariwisata" },
                    { label: "Kuota Bisnis dan Manajemen", id: "kuotaBisnisDanManajemen" },
                    { label: "Kuota Seni dan Ekonomi Kreatif", id: "kuotaSeniDanEkonomiKreatif" },
                    { label: "Kuota Agribisnis dan Agriteknologi", id: "kuotaAgribisnisDanAgriteknologi" },
                    { label: "Kuota Kemaritiman", id: "kuotaKemaritiman" },
                    { label: "Kuota Kesehatan dan Pekerjaan Sosial", id: "kuotaKesehatanDanPekerjaanSosial" },
                    { label: "Kuota Teknologi Informasi", id: "kuotaTeknologiInformasi" },
                    { label: "Kuota Teknologi Manufaktur dan Rekayasa", id: "kuotaTeknologiManufakturDanRekayasa" },
                    { label: "Kuota Teknologi Konstruksi dan Properti", id: "kuotaTeknologiKonstruksiDanProperti" },
                    { label: "Kuota Energi dan Pertambangan", id: "kuotaEnergiDanPertambangan" },
                ],
            });
        } else {
            this.setState({
                dataInputKuota: [
                    { label: "Kuota Matematika", id: "kuotaMatematika" },
                    { label: "Kuota Fisika", id: "kuotaFisika" },
                    { label: "Kuota Biologi", id: "kuotaBiologi" },
                    { label: "Kuota Kimia", id: "kuotaKimia" },
                    { label: "Kuota Informatika", id: "kuotaInformatika" },
                    { label: "Kuota Geografi", id: "kuotaGeografi" },
                    { label: "Kuota Sosiologi", id: "kuotaSosiologi" },
                    { label: "Kuota Ekonomi", id: "kuotaEkonomi" },
                    { label: "Kuota Antropologi", id: "kuotaAntropologi" },
                    { label: "Kuota Bhs Inggris", id: "kuotaBahasaInggris" },
                    { label: "Kuota Bhs Indonesia", id: "kuotaBahasaIndonesia" },
                    { label: "Kuota Bhs Asing", id: "kuotaBahasaAsing" },
                    { label: "Kuota Vokasi & Prakarya", id: "kuotaVokasiDanPrakarya" },
                ],
            });
        }
    }

    fetchTa = async () => {
        //fetch tahun ajaran dulu
        const resTa = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_LIST_TAHUN_AJARAN).catch(function (error) {});
        if (resTa) {
            if (resTa.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    ta: resTa.data.data,
                });
            }
        }

        resTa.data.data.map((val) => {
            if (val.status === "1") {
                this.setState({ kodeTahunAjaran: val.kodeTahunAjaran });
                this.setState((prevState) => {
                    let reqKuotaPemetaan = Object.assign({}, prevState.reqKuotaPemetaan);
                    reqKuotaPemetaan["kodeTahunAjaran"] = val.kodeTahunAjaran;
                    return { reqKuotaPemetaan };
                });
            }
        });
    };

    fetchKelas = async () => {
        this.setState({ isFetching: true });
        //fetch sekolah dulu
        const resSekolah = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_GET_SEKOLAH + this.props.account.idSekolah).catch(function (error) {});
        let kodeJenjang = null;
        if (resSekolah) {
            if (resSekolah.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                kodeJenjang = resSekolah.data.data.kodeJenjangSekolah;
            }
        }

        //fetch kelas setelah dapat data sekolah
        const response = await accountManagement
            .post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS, {
                KelasSearch,
                ["kodeJenjangSekolah"]: kodeJenjang,
            })
            .catch(function (error) {});
        // masukan data kelas ke dropdown
        if (response) {
            if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    kelas: response.data.data,
                });
            }
        }
        this.setState({ isFetching: false });
    };

    handleOnChangeInput = async (e) => {
        let name = e.target.name;
        let val = e.target.value;

        this.setState((prevState) => {
            let reqKuotaPemetaan = Object.assign({}, prevState.reqKuotaPemetaan);
            reqKuotaPemetaan[name] = val;
            return { reqKuotaPemetaan };
        });

        this.setState({
            [name]: val,
            listSiswa: [],
            isFetching: true,
        });

        // cari profil PEMINATAN
        if (name === "idKelas") {
            this.setState({
                isFetching: true,
                jadwalCbt: [],
                idJadwalCbt: "",
                jumlahPlacementSiswa: null,
                idKelas: val,
            });

            let tipePemetaan = undefined;
            if (this.props.location.pathname === "/report_pemetaan_input2") {
                tipePemetaan = "PEMETAAN2";
            } else {
                tipePemetaan = "PEMETAAN";
            }

            const response = await accountManagement
                .get(CONFIG.REPORT_CBT_GET_JADWAL, {
                    params: {
                        tahunAjaran: this.state.kodeTahunAjaran,
                        idSekolah: this.props.account.idSekolah,
                        idKelas: val,
                        tipeCbt: tipePemetaan,
                    },
                })
                .catch(function (error) {
                    console.log(error);
                });

            //fetch kelas pararelnya dulu
            this.state.KelasParalelSearch = [];
            const resKelasParalel = await accountManagement
                .post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS_PARALEL, {
                    KelasParalelSearch,
                    ["idKelas"]: val,
                    ["idSekolah"]: this.props.account.idSekolah,
                })
                .catch(function (error) {});

            // masukan kelas paralel ke  dropdown
            if (resKelasParalel) {
                if (resKelasParalel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                    this.setState({
                        KelasParalelSearch: resKelasParalel.data.data,
                    });
                }
            }

            if (response) {
                if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                    this.setState({
                        jadwalCbt: response.data.data,
                    });
                }
            }

            const fetchJumlahSiswaKelas = await accountManagement
                .post(CONFIG.REPORT_PEMETAAN2_COUNT_ALL_SISWA, {
                    kodeTahunAjaran: this.state.kodeTahunAjaran,
                    idKelas: val,
                })
                .catch(function (error) {
                    console.error(error);
                });

            if (fetchJumlahSiswaKelas.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                console.log("SUKSES");
                this.setState({
                    jumlahPlacementSiswa: fetchJumlahSiswaKelas.data.data.jumlahPlacementSiswa,
                });
            }

            this.setState({ isFetching: false });
        } else if (name === "idKelasParalel") {
            this.setState({ idKelasParalel: val });
        } else if (name === "kodeTahunAjaran") {
            this.setState({ kodeTahunAjaran: val, idKelas: "" });
        } else if (name === "idJadwalCbt") {
            const { idKelas, idKelasParalel, kodeTahunAjaran } = this.state;

            const resListSiswa = await accountManagement
                .post(CONFIG.REPORT_PEMETAAN_FETCH_LIST_PENGERJAAN_SISWA, {
                    idKelasParalel: idKelasParalel,
                    idKelas: idKelas,
                    idJadwalCbt: val,
                    kodeTahunAjaran: kodeTahunAjaran,
                })
                .then((data) => {
                    this.setState({ listSiswa: data.data.data.listSiswa });
                })
                .catch(function (error) {});
        }

        this.setState({
            isFetching: false,
        });
    };

    handleOnChangeTextField = async (e) => {
        let { id, value } = e.target;

        this.setState((prevState) => {
            let reqKuotaPemetaan = Object.assign({}, prevState.reqKuotaPemetaan);
            reqKuotaPemetaan[id] = parseInt(value);
            return { reqKuotaPemetaan };
        });
    };

    handleSubmit = async (e) => {
        this.setState({ isFetching: true });
        e.preventDefault();

        const responseValidate = await accountManagement.post(CONFIG.REPORT_PEMETAAN2_VALIDATE_COUNT_ALL_SISWA, this.state.reqKuotaPemetaan).catch(function (error) {
            console.error(error);
        });
        if (responseValidate) {
            if (responseValidate.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.props.history.push({
                    pathname: "/report_pemetaan2",
                    state: { payload: this.state.reqKuotaPemetaan },
                });
            } else {
                console.log("b");
                this.setState({
                    alert: responseValidate.data.errorSchema,
                });
            }
        }

        this.setState({ isFetching: false });
    };

    render() {
        const { kodeTahunAjaran, idKelas, jadwalCbt, idJadwalCbt, idKelasParalel, jumlahPlacementSiswa, listSiswa, urlSiswaReportingSMK, urlSiswaReportKU } = this.state;

        require("./index.css");
        return (
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account} />
                <div id="content" style={{ paddingBottom: "50px" }}>
                    <Navbar title="Pemetaan" />
                    {this.loadAlert()}
                    <form onSubmit={this.handleSubmit}>
                        <Grid spacing={2} container direction="row" justifyContent="space-between" alignItems="flex-start">
                            {/* GRID KIRI */}
                            <Grid item xs={12} sm={4}>
                                <Grid spacing={1} container direction="column" justifyContent="flex-start" alignItems="stretch">
                                    <Grid item>
                                        <Typography variant="body1">Pilihan</Typography>
                                    </Grid>

                                    <Grid item>
                                        <select className="form-control" name="kodeTahunAjaran" value={kodeTahunAjaran} onChange={this.handleOnChangeInput} required>
                                            <option value="" selected disabled>
                                                ~~ Pilih TahunAjaran ~~
                                            </option>
                                            <DropdownTahunAjaran tahunAjaran={this.state.ta} />
                                        </select>
                                    </Grid>

                                    <Grid item>
                                        <select className="form-control" name="idKelas" value={idKelas} onChange={this.handleOnChangeInput} required>
                                            <option value="" selected disabled>
                                                ~~ Pilih Kelas ~~
                                            </option>
                                            <DropdownKelas kelas={this.state.kelas} />
                                        </select>
                                    </Grid>

                                    <Grid item>
                                        <select className="form-control" name="idKelasParalel" value={idKelasParalel} onChange={this.handleOnChangeInput}>
                                            <option value="" selected>
                                                ~~ Pilih Kelas Paralel ~~
                                            </option>
                                            <DropdownKelasParalel kelasParalel={this.state.KelasParalelSearch} />
                                        </select>
                                    </Grid>

                                    <Grid item>
                                        <select className="form-control" name="idJadwalCbt" value={idJadwalCbt} onChange={this.handleOnChangeInput} required>
                                            <option value="" selected disabled>
                                                ~~ Pilih CBT ~~
                                            </option>
                                            {jadwalCbt.map((jadwal) => (
                                                <option value={jadwal.idJadwalCbt}>{jadwal.namaJadwalCbt}</option>
                                            ))}
                                        </select>
                                    </Grid>
                                </Grid>
                            </Grid>

                            {/* GRID KANAN */}
                            <Grid item xs={12} sm={8}>
                                <Grid item>
                                    <Typography variant="body1">Input Kuota placement ( {!jumlahPlacementSiswa ? "0" : jumlahPlacementSiswa} Kuota )</Typography>
                                </Grid>
                                <Gap height={9} />
                                <Grid spacing={1} container direction="column" justifyContent="flex-start" alignItems="stretch" className="gridQuota">
                                    {this.state.dataInputKuota.map((kuota) => (
                                        <Grid item>
                                            <TextField id={kuota.id} label={kuota.label} onChange={this.handleOnChangeTextField} type="number" variant="outlined" size="small" />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <button type="submit" value="Submit" className="btn btn-outline-primary">
                                    Generate Report
                                </button>
                                &nbsp;
                                {/* validasi memunculkan tombol */}
                                {this.props.account.idSekolah && idKelas && idJadwalCbt && kodeTahunAjaran && (
                                    <a
                                        href={env.REACT_APP_URL_PSEP_BE + "/pemetaan/generate_excell?idSekolah=" + this.props.account.idSekolah + "&idKelas=" + idKelas + "&idJadwalCbt=" + idJadwalCbt + "&kodeTahunAjaran=" + kodeTahunAjaran}
                                        type="submit"
                                        value="Submit"
                                        className="btn btn-outline-info"
                                    >
                                        Rekapitulasi
                                    </a>
                                )}
                            </Grid>

                            <Grid item xs={12}>
                                {!__.isEmpty(listSiswa) && <ListSiswa listSiswa={listSiswa} urlSiswaReporting={urlSiswaReportingSMK} urlSiswaReportKU={urlSiswaReportKU} idJadwalCbt={idJadwalCbt} />}
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </div>
        );
    }

    loadAlert = () => {
        const { errorCode, errorMessage } = this.state.alert;

        if (errorCode) {
            return (
                <Alert variant={CONFIG.SUCCESS_ERROR_CODE === errorCode ? "info" : "warning"} onClose={() => this.setState({ alert: {} })} dismissible>
                    <strong>{errorMessage}</strong>
                </Alert>
            );
        }
    };
}

const mapStateToProps = (state) => {
    return {
        account: state.account,
    };
};

export default connect(mapStateToProps, { cekCookies })(index);
